import { ITypedReduxAction } from '../../types/redux';

export enum EListingModalActionType {
  Toggle = 'listingModal/toggle',
  SetActiveOfferId = 'listingModal/setActiveOfferId',
  SetOffersFetchingMode = 'listingModal/setOffersFetchingMode',
}

export interface IToggleListingModalPayload {
  open: boolean;
  mode?: EListingModalMode;
  offersFetchingMode?: EOffersFetchingMode;
}

export enum EOffersFetchingMode {
  SINGLE = 'single',
  ALL = 'all',
  NONE = 'none',
}

export enum EListingModalMode {
  HALF_SCREEN = 'halfScreen',
  FULL_SCREEN = 'fullScreen',
  UNSET = 'unset',
}

export type TToggleListingModal = ITypedReduxAction<EListingModalActionType.Toggle, IToggleListingModalPayload>;
export type TSetActiveOfferId = ITypedReduxAction<EListingModalActionType.SetActiveOfferId, number | null>;
export type TSetOfferLoadingType = ITypedReduxAction<
  EListingModalActionType.SetOffersFetchingMode,
  EOffersFetchingMode
>;

export type TListingModalActions = TToggleListingModal | TSetActiveOfferId | TSetOfferLoadingType;
